
//export const cmsEntryPoint = "products.cmsProducts";
//export const cmsEntryPoint = "cms.dashboard";
export const cmsEntryPoint = "pages.cmsPage";